/**
 * 'core-js/statble/map' 和 'core-js/statble/set' 主要因为在
 * Android 4.4 以及以下的机型中，React 依赖模块中使用 Map 和 Set 两个接口
 * 而 Babel 并不会处理引入模块的转化，从而导致报错，引入这两个 polyfill 能
 * 解决这个问题
 */
import 'core-js/stable/map'
import 'core-js/stable/set'
import 'core-js/stable/symbol'
import 'core-js/stable/object/assign'
import 'amfe-flexible'
import React from 'react'
import ReactDOM from 'react-dom'

import { getNativeInfo } from './services/native'
import App from './App.js'

// 默认情况下 dev 模式下都是开放了 mock 功能，如果不需要 mock 功能
// const isProd = process.env.NODE_ENV === 'production'
// if (!isProd) {
//   require('../mock')
// }

/**
 * 全局保存 native 相关的信息，非 native 环境将不做任何操作, 环境中会保存如下字段：
 * env: 环境字段，值为 'iOS' 或 'Android'
 * osVersion: 当前安卓或者 iOS  版本
 * appVersion: 当前应用的版本
 * app: 当前是那个 app， 值为 'baicizhan' 或者 'ireading'
 * device: 设备名称，可以是 'iPhone' 'iPad' 以及 Android 的相应设备
 */
const info = getNativeInfo()
Object.keys(info).forEach(key => {
  info[key] ? localStorage.setItem(key, info[key]) : null
})

ReactDOM.render(<App />, document.getElementById('root'))
